import { ProfileData } from '@mews-commander/types';
import { getProfileData } from '@mews-commander/legacy-entities/src/ducks/profiles';
import { getCurrentEnterpriseProfileData } from '@mews-commander/legacy-entities/src/selectors/enterpriseProfiles';
import { useCommanderSelector } from '@mews-commander/utils';

export const useProfileData = (profileId: string): ProfileData | undefined => {
    const profileData = useCommanderSelector((state) => getProfileData(state, { id: profileId })) as ProfileData | null;

    const currentEnterpriseProfileData = useCommanderSelector((state) =>
        getCurrentEnterpriseProfileData(state, { id: profileId })
    );

    return profileData || currentEnterpriseProfileData;
};
